<div class="card">
  <div class="mb-3" *ngFor="let category of categories">
    <span class="ps-2 m-1 category-title"> {{ app.getText(category) }} </span>
    <app-field
      *ngFor="let field of app.getList(category); index as index"
      [model]="model"
      [field]="field"
      [index]="index"
      [disabled]="app.isLocked(model[getIdKey(category)])"
    ></app-field>
  </div>
</div>
